'use strict';

var _defineProperty = require("/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var basics = require('multiformats/basics');
var alloc = require('../alloc.js');
function createCodec(name, prefix, encode, decode) {
  return {
    name: name,
    prefix: prefix,
    encoder: {
      name: name,
      prefix: prefix,
      encode: encode
    },
    decoder: {
      decode: decode
    }
  };
}
var string = createCodec('utf8', 'u', function (buf) {
  var decoder = new TextDecoder('utf8');
  return 'u' + decoder.decode(buf);
}, function (str) {
  var encoder = new TextEncoder();
  return encoder.encode(str.substring(1));
});
var ascii = createCodec('ascii', 'a', function (buf) {
  var string = 'a';
  for (var i = 0; i < buf.length; i++) {
    string += String.fromCharCode(buf[i]);
  }
  return string;
}, function (str) {
  str = str.substring(1);
  var buf = alloc.allocUnsafe(str.length);
  for (var i = 0; i < str.length; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
});
var BASES = _objectSpread({
  utf8: string,
  'utf-8': string,
  hex: basics.bases.base16,
  latin1: ascii,
  ascii: ascii,
  binary: ascii
}, basics.bases);
module.exports = BASES;